import React from 'react';
type LogoProps = {
  className?: string;
  markClassName?: string;
  wordClassName?: string;
  showWord?: boolean;
};
const HAERUMBAH_LOGO = 'https://cdn.magicpatterns.com/uploads/89KCkFv1aQXv19aDFXcxDZ/ChatGPT_Image_Jul_22,_2026,_04_19_06_PM.png';

/** Official Haerumbah mark paired with the corporate wordmark. */
export function Logo({
  className = '',
  markClassName = '',
  wordClassName = '',
  showWord = true
}: LogoProps) {
  return <span className={`inline-flex items-center gap-2.5 ${className}`} data-id="element-15" data-mp="u1nhh0sf4ehd">
      <LogoMark className={markClassName} data-id="element-16" data-mp="yzf7tqdezsjg" />
      {showWord && <span className={`font-semibold tracking-tightest text-ink ${wordClassName}`} data-id="element-17" data-mp="13x78p9w1eozs">
          Haerumbah
        </span>}
    </span>;
}
export function LogoMark({
  className = ''
}: {
  className?: string;
}) {
  return <img src={HAERUMBAH_LOGO} alt="" aria-hidden="true" className={`${className || 'h-6 w-6'} rounded-full object-cover`} data-id="element-18" data-mp="2fcm6gfw2lkvy" />;
}